import * as types from "../constants/action_types";

const initialState = {};

function company(state = initialState, action) {
  switch (action.type) {
  case types.FETCH_COMPANY:
  case types.UPDATE_COMPANY:
    return Object.assign({}, action.company);
  default:
    return state;
  }
}

export default company;
